export const languages = [
  { 'label': 'English', 'value': 'ENG' },
  { 'label': 'Russian', 'value': 'RUS' },
  { 'label': 'German', 'value': 'DEU' },
  { 'label': 'French', 'value': 'FRA' },
  { 'label': 'Italian', 'value': 'ITA' },
  { 'label': 'Japanese', 'value': 'JPN' },
  { 'label': 'Korean', 'value': 'KOR' },
  { 'label': 'Portuguese', 'value': 'PTG' },
  { 'label': 'Spanish', 'value': 'ESP' },
  { 'label': 'Swedish', 'value': 'SVE' },
  { 'label': 'Thai', 'value': 'THA' },
  { 'label': 'Turkish', 'value': 'TRK' },
  { 'label': 'Vietnamese', 'value': 'VIE' },
  { 'label': 'Chinese Traditional', 'value': 'CHT' },
  { 'label': 'Chinese Simplified', 'value': 'CHS' },
  { 'label': 'Hindi', 'value': 'HIN' },
  { 'label': 'Polish', 'value': 'PLK' },
  { 'label': 'Indonesian', 'value': 'IND' },
  { 'label': 'Hebrew', 'value': 'HEB' },
];
